module.exports = __webpack_public_path__ + "static/media/Okanogan Logo.5247f18f.png";